export enum KnowledgeQuizStatus {
  ToDo = 'ToDo',
  Started = 'Started',
  Passed = 'Passed',
  Failed = 'Failed',
}
